import { motion } from "framer-motion";
import { LogoMark } from "./Logo";

export const ThankYou = () => (
  <motion.div data-testid="funnel-thank-you" initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} className="flex min-h-[380px] flex-col items-start justify-center">
    <motion.div initial={{ scale: 0.6, opacity: 0, x: -30 }} animate={{ scale: 1, opacity: 1, x: 0 }} transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}>
      <LogoMark className="h-14 w-auto" />
    </motion.div>
    <h3 className="mt-8 font-display text-3xl sm:text-5xl font-semibold tracking-[-0.03em]">Danke – Ihr Pool-Check ist da.</h3>
    <p className="mt-4 max-w-lg text-[var(--mist)]">Wir sehen uns Ihre Angaben an und melden uns persönlich bei Ihnen, um die nächsten Schritte für Ihren Pool zu besprechen.</p>
  </motion.div>
);
